<script>
import XmlChannelStatusCardHeader from './XmlChannelStatusCardHeader';
import dateMixin from '../../mixins/dateMixin';

export default {
  name: 'XmlChannelStatusXmlCard',
  components: {
    XmlChannelStatusCardHeader,
  },
  mixins: [
    dateMixin,
  ],
  props: {
    xmlChannel: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formatter: new Intl.NumberFormat('da-DK', { maximumFractionDigits: 0, minimumFractionDigits: 0 }),
    };
  },
  methods: {
    openJobList(xmlChannel) {
      this.$emit('open-job-list', xmlChannel);
    },
    activateLatestJob(xmlChannel) {
      this.$emit('activate-latest-job', xmlChannel);
    },
    getSyncDuration(xmlExport) {
      if (xmlExport.endTime) {
        return this.getFormattedDuration(xmlExport.startTime, xmlExport.endTime);
      }
      return this.getFormattedDuration(xmlExport.startTime, this.$moment.utc().format('YYYY-MM-DD HH:mm:ss'));
    },
    getPercentProgress(xmlExport) {
      if (!xmlExport.message) {
        return '';
      }
      const match = xmlExport.message.match(/\s(\d{1,2}%)/);
      return match ? match[0] : '0%';
    },
  },
};
</script>

<template>
  <v-flex v-if="xmlChannel.latestJob">
    <xml-channel-status-card-header :xml-channel="xmlChannel"/>
    <v-card-text class="pt-0 pb-1 mt-2">
      <span>
        <strong>Prices:</strong>
      </span>
      <span>{{ formatter.format(xmlChannel.latestJob.rows) }}</span>
    </v-card-text>
    <v-card-text class="py-0">
      <b>Import:</b>
    </v-card-text>
    <v-card-text class="pt-0 pb-1 pl-4">
      <span>
        Started:
      </span>
      <span>{{  formatDate(xmlChannel.latestJob.runStart) }}</span>
    </v-card-text>
    <v-card-text class="pt-0 pb-1 pl-4">
      <span>
        Finished:
      </span>
      <span v-if="xmlChannel.latestJob.runEnd">
        {{ formatDate(xmlChannel.latestJob.runEnd) }}
        ({{ getFormattedDuration(xmlChannel.latestJob.runStart, xmlChannel.latestJob.runEnd) }})
      </span>
      <span v-else class="pl-2">-</span>
    </v-card-text>
    <v-card-text class="py-0">
      <b>Synchronization:</b>
    </v-card-text>
    <v-card-text class="pt-0 pb-1 pl-4">
      <span>
        Started:
      </span>
      <span v-if="xmlChannel.latestJob.export">
        {{ formatDate(xmlChannel.latestJob.export.startTime) }}
      </span>
      <span v-else class="pl-2">-</span>
    </v-card-text>
    <template v-if="xmlChannel.latestJob.export">
      <v-card-text
        v-if="xmlChannel.latestJob.export.endTime"
        class="pt-0 pb-1 pl-4"
      >
        <span>
          Finished:
        </span>
        {{ formatDate(xmlChannel.latestJob.export.endTime) }}
        ({{ getSyncDuration(xmlChannel.latestJob.export) }})
      </v-card-text>
      <v-card-text v-else class="pt-0 pb-1 pl-4">
        <span>
          Progress:
        </span>
        <template v-if="xmlChannel.latestJob.export.message">
          <span class="font-weight-bold">
            {{ getPercentProgress(xmlChannel.latestJob.export) }}
          </span>
          -
        </template>
        {{ getSyncDuration(xmlChannel.latestJob.export) }}
      </v-card-text>
    </template>
    <v-card-text v-else class="pt-0 pb-1 pl-4">
      <span>
        Finished:
      </span>
      <span class="pl-2">-</span>
    </v-card-text>
    <v-divider class="mx-2 pt-1"/>
    <v-btn @click="openJobList(xmlChannel)" color="primary" outline small>
      {{ $t('xmlChannelStatus.xmlChannelStatusCard.jobList') }}
    </v-btn>
    <v-btn
      v-if="xmlChannel.latestJob.status === 'WARNING'"
      @click="activateLatestJob(xmlChannel)"
      :color="`${xmlChannel.latestJob.rows > 0 ? 'success' : 'warning' }`"
      small
    >
      Activate
    </v-btn>
  </v-flex>
  <v-flex v-else>
    <v-card-title dark>
      {{ xmlChannel.webservice }}
      <v-spacer />
      <small>{{ xmlChannel.system }}</small>
      <v-spacer />
      <badge :badge="badges['NO_CONTENT']"/>
    </v-card-title>
  </v-flex>
</template>



// WEBPACK FOOTER //
// src/components/xmlChannelStatus/XmlChannelStatusXmlCard.vue